export default __webpack_public_path__ + "static/media/natifLuxury.5273567b.svg";